<script>
	import { onMount } from "svelte";
	import Drawer from "#/toolbars/Drawer";
	import DrawerPOS from "#/toolbars/DrawerPOS";
	import MediaQuery from "@/assets/components/MediaQuery";
	import { ToastContainer } from "svelte-toasts";
	import JhToast from "#/atoms/JhToast.svelte";
	import RouterView from "@/router/index";
	import DeliveryNotification from "#/admin/DeliveryNotification.svelte";
	import { initTenant } from "@/assets/js/tenant";
	import { initUserFromSession } from "@/assets/js/auth";
	import { refreshAgeStatus } from "@/assets/js/ageGate";
	import { bootstrapStorefrontCatalog } from "@/assets/js/storefrontCatalog";
	import { listVisibleTenantCategories } from "@/assets/js/categoryInventory";
	import tenant from "@/store/tenant.js";
	import { get } from "svelte/store";
	import { loadIcons } from "@iconify/svelte";
	import { SITE_ICONS } from "@/assets/js/icons";
	import { initSiteAnalytics } from "@/assets/js/siteAnalytics";

	let initialized = false;

	onMount(async () => {
		await initTenant();
		// Restore the session and age-verification status BEFORE building the catalog, so
		// age-restricted (snus) items are masked/unmasked correctly for the current viewer.
		initUserFromSession();
		await refreshAgeStatus();
		const t = get(tenant);
		if (t.id) {
			// A failed fetch (server unreachable) must not leave the app stuck on the
			// spinner — the POS can still open from its offline copy.
			await Promise.all([
				bootstrapStorefrontCatalog(),
				listVisibleTenantCategories(t.id),
			]).catch((e) => console.error("Catalog bootstrap failed", e));
		}
		initSiteAnalytics();
		initialized = true;
		loadIcons(SITE_ICONS);
	});
</script>

<section class="col vh100 overflow-hidden" id="app">
	{#if initialized}
		<RouterView />
		<Drawer />
		<DrawerPOS />
		<MediaQuery />
		<ToastContainer placement="bottom-right" width="380px" let:data>
			<JhToast {data} />
		</ToastContainer>
		<DeliveryNotification />
	{:else}
		<div class="center vh100 boot-screen">
			<div class="loading-spinner"></div>
		</div>
	{/if}
</section>

<style>
	.boot-screen {
		background: #000;
	}

	.loading-spinner {
		width: 40px;
		height: 40px;
		border: 3px solid rgba(255, 255, 255, 0.2);
		border-top: 3px solid #fff;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>
